import React, { useEffect, useState, useMemo, useRef, use } from "react"
import { RouteAdmin } from "../../../../routes/RouteAdmin"

import { Box, Button, Link, Divider, Modal } from "@mui/material"

import { listApi } from "../../../../services/Admin/request"
import { apiGetMediaElement, apiGetMediaVerifactur } from "../../../../services/Admin/media"
import { showServicesApi } from "../../../../services/Admin/service"
import { showUsersByRoleApi } from "../../../../services/Admin/user"
import { addManualTransaction, getTransactionByID, exportTransaction, apiTransactionUpdateDatePayment, apiTransactionResendVerifactu } from "../../../../services/Admin/transaction"

import TableC from "../../../../components/Admin/TableC"
import LoadingProgress from "../../../../components/LoadingProgress"
import timestampToDate from "../../../../components/timestampToDate"
import { getMimeTypeByFormat } from "../../../../components/Admin/Media/mediaUtils"
import Card from "../../../../components/Admin/Card"

import CronJobInfo from "./CronJobInfo"
import ExportModal from "./ExportModal"
import InvoiceModal from "./InvoiceModal"
import DatePaymentModal from "./DatePaymentModal"
import MotivoRechazoModal from "./MotivoRechazoModal"
import ModalSendTransaction from "./ModalSendTransaction"

import { IconButton, Menu, MenuItem } from "@mui/material"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import { CheckCircle, XCircle, Send, Clock, AlertTriangle } from 'lucide-react';

import ListSubheader from '@mui/material/ListSubheader'
import { styled } from '@mui/material/styles'

const StyledListHeader = styled(ListSubheader)({
  backgroundImage: 'var(--Paper-overlay)',
})

export default function Management() {
    const [transactions, setTransactions] = useState(null)
    // Estado para el tipo de IVA
    const [tipoIva, setIvaType] = useState("")
    const [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false)
    const [openExport, setOpenExport] = useState(false)
    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgSuccessExport, setMsgSuccessExport] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [msgDangerModal, setMsgDangerModal] = useState(null)
    const [spiner, setSpiner] = useState(false)
    const [spinerModal, setSpinerModal] = useState(false)
    const [invoiceID, setInvoinceID] = useState("")
    const [dateBill, setDateBill] = useState()
    const [dateOperation, setDateOperation] = useState()
    const [dateOriginalBill, setDateOriginalBill] = useState()
    const [dateOperationOriginal, setDateOperationOriginal] = useState()
    const [motivo, setMotivo] = useState("")
    const [concepto, setConcepto] = useState("")
    const [price, setPrice] = useState("")
    const [subtotal, setSubtotal] = useState("")
    const [iva, setIva] = useState("")
    const [invoiceTypeSpecial, setInvoiceTypeSpecial] = useState(false)
    const [invoicePdf, setInvoicePdf] = useState(null)
    const [invoiceShowPrice, setInvoiceShowPrice] = useState(true)

    const [listUserClient, setListUserClient] = useState([])
    const [defaultUserClientValueList, setDefaultUserClientValueList] = useState({})
    const [idClient, setIdClient] = useState(null)
    const [isClientSelect, setIsClientSelect] = useState(false)
    const timeoutRef = useRef(null)

    const [dateExportStart, setDateExportStart] = useState()
    const [dateExportEnd, setDateExportEnd] = useState()
    const [msgDangerModalExport, setMsgDangerModalExport] = useState(null)
    const [spinerModalExport, setSpinerModalExport] = useState(false)

    const [servicios, setServicios] = useState([])
    const [servicioSeleccionado, setServicioSeleccionado] = useState(null)
    const [serviciosAñadidos, setServiciosAñadidos] = useState([])

    const [openDatePayment, setOpenDatePayment] = useState(false)
    const [spinerModalDatePayment, setSpinerModalDatePayment] = useState(false)
    const [msgDangerModalDatePayment, setMsgDangerModalDatePayment] = useState(null)
    const [datePaymentValue, setDatePaymentValue] = useState("")
    const [selectedTransactionId, setSelectedTransactionId] = useState(null)
    const [modalSendTransaction, setModalSendTransaction] = useState(false)

    const [globalFilter, setGlobalFilter] = useState("")

    const handleOpen = () => {
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setSpiner(false)
        setSpinerModal(false)
        setDateBill(new Date().toISOString().split("T")[0]) // Fecha de hoy por defecto en formato YYYY-MM-DD
        setDateOperation(new Date().toISOString().split("T")[0]) // Fecha de hoy por defecto en formato YYYY-MM-DD
        setDateOriginalBill(null)
        setDateOperationOriginal(null)
        setInvoinceID(null)
        setMotivo("")
        setConcepto("")
        setPrice("")
        setIva("")
        setInvoiceTypeSpecial(false)
        setDefaultUserClientValueList(null)
        setIdClient(null)
        setIsClientSelect(false)
        setInvoicePdf(null)
        setOpen(true)
        setServicioSeleccionado(null)
        setServiciosAñadidos([])
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleOpenExport = () => {
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setMsgSuccessExport(false)
        setMsgDangerModalExport(null)
        setSpinerModalExport(false)
        setDateExportStart("")
        setDateExportEnd("")
        setOpenExport(true)
    }
    const handleCloseExport = () => setOpenExport(false)

    // Nueva función para abrir el modal de fecha de pago
    const handleOpenDatePayment = (transactionId) => {
        setSelectedTransactionId(transactionId)
        setDatePaymentValue("")
        setMsgDangerModalDatePayment(null)
        setOpenDatePayment(true)
    }

    const handleCloseDatePayment = () => {
        setOpenDatePayment(false)
        setSelectedTransactionId(null)
        setDatePaymentValue("")
        setMsgDangerModalDatePayment(null)
    }

    // Nueva función para reenviar a Verifactu
    const handleResendVerifactu = async (transactionId) => {
        setLoading(true)
        apiTransactionResendVerifactu({ transactionId }).then(resp => {
            if (resp.data.status) {
                window.location.reload();
            } else {
                setMsgDanger(resp.data?.errors || ["Error al reenviar a Verifactu"])
                setLoading(false)
            }
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors || ["Error al reenviar a Verifactu"])
            setLoading(false)
        })
    }
    // Descarga el XML de Verifactur
    const handleDownloadXml = async (hrefXml, selectedFile) => {
        try {
            const resp = await apiGetMediaVerifactur(hrefXml);
            const base64Content = resp.data?.content;
            const format = resp.data?.format || selectedFile?.format || "xml";

            // Cogemos el fichero que hay al final del path de hrefXml si no viene otro nombre (formato: ID/xml/filename.xml)
            const parts = hrefXml.split("/");
            const lastPart = parts[parts.length - 1];

            if (base64Content) {
                const filename = lastPart || selectedFile?.verifactuXml || `archivo.${format}`;
                const mimeType = getMimeTypeByFormat(format);
                const link = document.createElement("a");
                link.href = `data:${mimeType};base64,${base64Content}`;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error descargando XML:", error);
        }
    };

    const handleOpenSendTransaction = transactionId => {
        setModalSendTransaction(true)
        setSelectedTransactionId(transactionId)
    }

    const columns = useMemo(
        () => [
            {
                Header: "FECHA DE EMISIÓN",
                accessor: "date",
            },
            {
                Header: "NUMERO FACTURA",
                accessor: "invoiceNumber",
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start', minWidth: 180 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ color: '#333', letterSpacing: '0.5px' }}>{row.original.invoiceNumber}</span>
                            {row.original.referencedInvoiceNumber && (
                                <span
                                    title="Factura referenciada"
                                    style={{
                                        color: "#8c760a",
                                        background: "#fffbe6",
                                        borderRadius: "4px",
                                        padding: "2px 8px",
                                        fontSize: "0.92em",
                                        fontStyle: "italic",
                                        border: "1px dashed #8c760a",
                                        opacity: 0.95,
                                        marginRight: 2,
                                        display: 'inline-block',
                                        marginLeft: "-8px",
                                    }}
                                >
                                    Ref: {row.original.referencedInvoiceNumber}
                                </span>
                            )}
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 2 }}>
                            {row.original.abonoParentInvoice && (
                                <span
                                    title="Factura padre de abono"
                                    style={{
                                        color: "#1976d2",
                                        background: "#e3f2fd",
                                        borderRadius: "4px",
                                        padding: "2px 8px",
                                        fontSize: "0.85em",
                                        fontStyle: "italic",
                                        border: "1px solid #1976d2",
                                        opacity: 0.95,
                                        marginRight: 2,
                                        display: 'inline-block',
                                    }}
                                >
                                    Abono: {row.original.abonoParentInvoice}
                                </span>
                            )}
                            {row.original.abonadoInvoiceNumber && (
                                <span
                                    title="Factura abonada"
                                    style={{
                                        color: "#388e3c",
                                        background: "#e8f5e9",
                                        borderRadius: "4px",
                                        padding: "2px 8px",
                                        fontSize: "0.85em",
                                        fontStyle: "italic",
                                        border: "1px solid #388e3c",
                                        opacity: 0.95,
                                        marginRight: 2,
                                        display: 'inline-block',
                                    }}
                                >
                                    Abonada: {row.original.abonadoInvoiceNumber}
                                </span>
                            )}
                        </div>
                    </div>
                )
            },
            {
                Header: "Estado AEAT",
                accessor: "verifactuEstadoAeat",
                Cell: ({ row }) => {
                    const estado = row.original.verifactuEstadoAeat;
                    // Mapeo de estados a texto, color e icono
                    const statusMap = {
                        pendiente: {
                            text: 'Pendiente',
                            color: '#FFA500',
                            Icon: Clock
                        },
                        enviado: {
                            text: 'Enviado',
                            color: '#1976d2',
                            Icon: Send
                        },
                        aceptado: {
                            text: 'Aceptado',
                            color: '#43a047',
                            Icon: CheckCircle
                        },
                        rechazado: {
                            text: 'Rechazado',
                            color: '#d32f2f',
                            Icon: XCircle
                        },
                        error: {
                            text: 'Error',
                            color: '#b71c1c',
                            Icon: XCircle
                        },
                        AceptadoConErrores: {
                            text: 'Aceptado',
                            color: '#FFA500',
                            Icon: AlertTriangle
                        },
                    };
                    const status = statusMap[estado] || { text: estado, color: '#757575', Icon: null };
                    const Icon = status.Icon;

                    return (
                        <>
                            {estado ? (
                                <span
                                    onClick={() => handleOpenMotivoRechazo(row.original.verifactuRespuestaAeat)}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '2px 12px',
                                        borderRadius: '12px',
                                        background: status.color + '22',
                                        color: status.color,
                                        fontWeight: 600,
                                        fontSize: '0.95em',
                                        letterSpacing: '0.5px',
                                        border: `1px solid ${status.color}`,
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        transition: 'box-shadow 0.2s',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                                    }}
                                    title="Ver motivo"
                                >
                                    {Icon && <Icon size={18} style={{ color: status.color, marginTop: "-8.5px" }} />}
                                    {status.text ? status.text.charAt(0).toUpperCase() + status.text.slice(1) : ''}
                                </span>
                            ) : null}
                        </>
                    );
                },
            },
            {
                Header: "MINUTOS",
                accessor: "totalTime",
                Cell: ({ row }) => {
                    return (
                        <>
                            {row.original.totalTime}
                        </>
                    );
                },
            },
            {
                Header: "CIF",
                accessor: "dni",
            },
            {
                Header: "CLIENTE",
                accessor: "client",
            },
            {
                Header: () => (
                    <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>
                        PRECIO (SIN IVA)
                    </span>
                ),
                accessor: "totalPrice",
                Cell: ({ row }) => {
                    const value = row.original.totalPrice;
                    let formatted = value;
                    if (typeof value === 'number') {
                        formatted = value.toFixed(2).replace('.', ',');
                    } else if (typeof value === 'string' && value.match(/^\d+(\.\d+)?$/)) {
                        formatted = parseFloat(value).toFixed(2).replace('.', ',');
                    }
                    return (
                        <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>
                            {formatted} €
                        </span>
                    );
                },
            },
            {
                Header: () => (
                    <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>
                        TOTAL (CON IVA)
                    </span>
                ),
                accessor: "totalPriceIva",
                Cell: ({ row }) => {
                    const value = row.original.totalPriceIva;
                    let formatted = value;
                    if (typeof value === 'number') {
                        formatted = value.toFixed(2).replace('.', ',');
                    } else if (typeof value === 'string' && value.match(/^\d+(\.\d+)?$/)) {
                        formatted = parseFloat(value).toFixed(2).replace('.', ',');
                    }
                    return (
                        <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>
                            {formatted} €
                        </span>
                    );
                },
            },
            {
                Header: "FECHA PAGO",
                accessor: "datePayment",
            },
            {
                Header: " ",
                accessor: "",
                Cell: ({ row }) => {
                    // Un solo tag, estilo similar a VERIFACTU
                    const isAuto = row.original.fAuto === "Sí" || row.original.fAuto === true || row.original.fAuto === "AUTO";
                    const isEnviado = row.original.eAuto === "Sí" || row.original.eAuto === true || row.original.eAuto === "ENVIADO A CLIENTE";
                    // Colores neutros para AUTO/MANUAL
                    const colorAuto = isAuto ? '#1976d2' : '#757575';
                    const bgAuto = isAuto ? '#e3f2fd' : '#f5f5f5';
                    const colorEnviado = isEnviado ? '#1976d2' : '#757575';
                    const bgEnviado = isEnviado ? '#e3f2fd' : '#f5f5f5';
                    // El borde exterior siempre gris
                    return (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                border: '1px solid #bdbdbd',
                                fontWeight: 600,
                                fontSize: '0.95em',
                                letterSpacing: '0.5px',
                                minWidth: 180,
                                background: '#fff',
                                transition: 'box-shadow 0.2s',
                            }}
                        >
                            <span
                                style={{
                                    padding: '2px 18px',
                                    background: bgAuto,
                                    color: colorAuto,
                                    minWidth: 100,
                                    textAlign: 'center',
                                    display: 'inline-block',
                                    transition: 'background 0.2s',
                                }}
                            >
                                {isAuto ? 'AUTO' : 'MANUAL'}
                            </span>
                            <span
                                style={{
                                    padding: '2px 18px',
                                    background: bgEnviado,
                                    color: colorEnviado,
                                    minWidth: 110,
                                    textAlign: 'center',
                                    display: 'inline-block',
                                    transition: 'background 0.2s',
                                }}
                            >
                                {isEnviado ? 'ENVIADO' : 'NO ENVIADO'}
                            </span>
                        </span>
                    );
                },
            },
            {
                Header: " ",
                accessor: "actions",
            }
        ],
        []
    )

    const getFacturas = async () => {
        setLoading(true)
        listApi("transaction").then(resp => {

            let temp = null
            let fAuto = "No"
            let eAuto = "No"
            temp = resp.data.data.map((doc) => {
                let hrefClient = `${RouteAdmin.USER_EDIT.path}/${doc.idUser.id}`

                fAuto = "No"
                if (doc.autoFactura === true) {
                    fAuto = "Sí"
                }
                eAuto = "No"
                if (doc.autoEnvio === true) {
                    eAuto = "Sí"
                }
                return {
                    ...doc,
                    date: timestampToDate(doc.date, false),
                    datePayment: doc.datePayment ? timestampToDate(doc.datePayment, false) : "-",
                    client: `${doc.idUser.name} ${doc.idUser.surnames}`,
                    fAuto: fAuto,
                    eAuto: eAuto,
                    dni: doc.idUser.dni,
                    cc: doc.idUser.cc,
                    actions: (
                        <ActionsMenu
                            doc={doc}
                            handleDownload={handleDownload}
                            handleDownloadXml={handleDownloadXml}
                            hrefClient={hrefClient}
                            handleOpenDatePayment={handleOpenDatePayment}
                            handleResendVerifactu={handleResendVerifactu}
                            handleOpenSendTransaction={handleOpenSendTransaction}
                        />
                    )
                }
            })
            setTransactions(temp)
            setLoading(false)
        }).catch(error => {
            console.error(error)
        })
    }

    // Lista con todos los clientes de la plataforma
    const getClients = async () => {
        showUsersByRoleApi({ roleName: "ROLE_CLIENT" }).then(resp => {
            if (resp.data.status) {
                const temp = resp.data.data.map((doc) => {
                    return {
                        id: doc.id,
                        ...doc,
                    }
                })
                setListUserClient(temp)
            }
        })
    }

    const getFacturaById = async (id) => {
        setSpinerModal(true)
        setMsgDangerModal(null)
        setDefaultUserClientValueList(null)
        setIsClientSelect(false)
        setIdClient(null)
        setPrice("")
        setIva("")
        setMotivo("")
        getTransactionByID({ invoice_number: id }).then(resp => {
            if (resp.data.status) {
                if (resp.data.data != null) {
                    setMsgDangerModal(null)

                    const data = resp.data.data
                    const ivaDb = data.ivaType / 100

                    setIdClient(data.idUser.id)
                    setDefaultUserClientValueList({
                        id: data.idUser.id,
                        name: data.idUser.name,
                        surnames: data.idUser.surnames,
                        email: data.idUser.email
                    })
                    if (data.totalPriceIva != null) {
                        setPrice(data.totalPriceIva)

                    } else {
                        let priceWithIVa = (parseFloat(data.totalPrice) * (1+ivaDb/100)).toFixed(2) // Assuming a fixed IVA of 21%
                        setPrice(priceWithIVa)
                    }
                    setIvaType(String(data.ivaType))
                    setIva((data.totalPrice * ivaDb).toFixed(2)) // Assuming a fixed IVA of 21%
                    setSubtotal(data.totalPrice)
                    setDateOriginalBill(data.date)
                    setMotivo("Factura de abono, rectifica a factura número: " + data.invoiceNumber)
                    setIsClientSelect(true)

                } else {
                    setDateOriginalBill(null)
                    setMsgDangerModal(["No se ha encontrado la factura con el ID proporcionado."])
                }

            }
        }).finally(() => {
            setSpinerModal(false)
        })
    }

    const changeClient = (event, value) => {
        if (value !== null) {
            setIdClient(value.id)
            setDefaultUserClientValueList({
                id: value.id,
                name: value.name,
                surnames: value.surnames,
                email: value.email
            })
            setIsClientSelect(true)
        } else {
            removeClient()
        }
    }

    const removeClient = () => {
        setDefaultUserClientValueList(null)
        setIsClientSelect(false)
        setIdClient(null)
    }

    const handleChangeInvoiceID = (value) => {
        setInvoinceID(value)

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            if (value !== "") {
                getFacturaById(value)
            } else {
                setDefaultUserClientValueList(null)
                setIsClientSelect(false)
                setIdClient(null)
                setPrice("")
                setIva("")
                setMotivo("")
            }
        }, 1500)
    }

    const handleChageDate = (event, value) => {
        setDateBill(event.target.value)
    }

    const handleChangePrice = (value) => {
        // Normalize entrada
        const normalized = String(value).replace(",", ".");
        const total = parseFloat(normalized) || 0;

        const ivaRate = tipoIva / 100;

        // Càlcul en cèntims: més precís
        const totalCents = Math.round(total * 100);
        const subtotalCents = Math.round(totalCents / (1 + ivaRate));
        const ivaCents = totalCents - subtotalCents;

        // Actualitzem estat amb format europeu
        setPrice(value); 
        setSubtotal((subtotalCents / 100));
        setIva((ivaCents / 100));
    };

    const createInvoice = async () => {
        setMsgDanger(null)
        setMsgDangerModal(null)
        setInvoicePdf(null)
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setSpiner(true)

        if (!dateBill) {
            setMsgDangerModal(["Debe seleccionar una fecha de emisión para la factura."])
            setSpiner(false)
            return
        }

        if (invoiceTypeSpecial && !invoiceID) {
            setMsgDangerModal(["Debe introducir el ID de la factura a abonar."])
            setSpiner(false)
            return
        }

        if (idClient === null || idClient === undefined) {
            setMsgDangerModal(["Debe seleccionar un cliente para la factura."])
            setSpiner(false)
            return
        }

        if (!price) {
            setMsgDangerModal(["Debe introducir el importe TOTAL para la factura"])
            setSpiner(false)
            return
        }

        if (!iva) {
            setMsgDangerModal(["Debe introducir el IVA para la factura"])
            setSpiner(false)
            return
        }

        if (!concepto) {
            setMsgDangerModal(["Debe introducir un concepto para la factura"])
            setSpiner(false)
            return
        }

        // Obtener el DNI del cliente selecionado esta en la lista de clientes
        const clientDni = listUserClient.find(client => client.id === idClient)?.dni || defaultUserClientValueList?.dni || "";
        // Validar que el DNI es correcto (8 dígitos + letra) o lestra + 8 dígitos
        const dniRegex = /^(\d{8}[A-Za-z]|[A-Za-z]\d{8})$/;
        if (!dniRegex.test(clientDni)) {
            setMsgDangerModal(["El DNI del cliente seleccionado no es válido."])
            setSpiner(false)
            return
        }

        addManualTransaction({
            dateBill: dateBill,
            dateOperation: dateOperation,
            idClient: idClient,
            invoiceTypeSpecial: invoiceTypeSpecial,
            invoiceID: invoiceID,
            motivo: motivo,
            concepto: concepto,
            price: price,
            subtotal: subtotal,
            iva: iva,
            ivaType: tipoIva,
            servicios: serviciosAñadidos,
            invoiceShowPrice: invoiceShowPrice ? 1 : 0
        }).then(resp => {
            if (resp.data.status) {
                handleDownload(resp.data?.data.file, `${resp.data?.data?.invoiceNumber}.pdf`)
                setInvoicePdf(resp.data?.data)
                setMsgSuccess(true)
            } else {
                setMsgDanger(resp.data?.errors)
            }
            setOpen(false)
            setSpiner(false)
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
            setOpen(false)
            setSpiner(false)
        })
    }

    const createExport = async () => {
        setMsgDangerModalExport(null)
        setSpinerModalExport(true)
        setMsgDanger(null)
        setMsgSuccess(false)
        setMsgSuccessExport(false)

        if (!dateExportStart) {
            setMsgDangerModalExport(["Debe seleccionar una fecha de inicio para la exportación."])
            setSpinerModalExport(false)
            return
        }

        if (!dateExportEnd) {
            setMsgDangerModalExport(["Debe seleccionar una fecha de fin para la exportación."])
            setSpinerModalExport(false)
            return
        }

        try {
            const response = await exportTransaction({
                dateExportStart,
                dateExportEnd
            })

            const contentType = response.headers['content-type']

            if (contentType.includes('application/json')) {
                // La respuesta es JSON => error
                const text = await response.data.text() // response.data es Blob
                const json = JSON.parse(text)
                setMsgDanger(json.errors || ["Error desconocido en la exportación."])
                handleCloseExport()
            } else {

                // Crear enlace de descarga
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob)

                const link = document.createElement('a')
                link.href = url

                const now = new Date()
                const formattedDate = now.toISOString().slice(0, 19).replace(/[-:T]/g, '')
                const filename = `facturas_export_${formattedDate}.xlsx`
                link.download = filename


                document.body.appendChild(link)
                link.click()
                link.remove()

                setOpenExport(false)
                setMsgSuccessExport(true)
            }
        } catch (err) {
            setMsgDanger(["Error al generar el fichero de exportación."])
            console.error(err)
        }

        setSpinerModalExport(false)
    }

    const handleDownload = (file, filename) => {
        if (file) {
            // Si inicialmente inicia con https
            if (file.startsWith("https")) {
                window.open(file, "_blank")
                return
            }
            apiGetMediaElement(file).then(resp => {
                const base64Content = resp.data?.content;
                const format = 'pdf';
                if (base64Content) {
                    const filenameIn = filename || `archivo.${format || "pdf"}`;
                    const mimeType = getMimeTypeByFormat(format);
                    const link = document.createElement("a");
                    link.href = `data:${mimeType};base64,${base64Content}`;
                    link.download = filenameIn;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
    };

    const getServicesType = async () =>{
        showServicesApi().then(resp => {
            // Filtrar solo los servicios activos
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map(doc => ({ ...doc }));
            setServicios(temp)
        }).catch(err => {
            console.error(err)
        })
    }

    const saveDatePayment = async () => {
        setMsgDangerModalDatePayment(null)
        setSpinerModalDatePayment(true)

        if (!datePaymentValue) {
            setMsgDangerModalDatePayment(["Debe seleccionar una fecha de pago."])
            setSpinerModalDatePayment(false)
            return
        }

        apiTransactionUpdateDatePayment({
            transactionId: selectedTransactionId,
            datePayment: datePaymentValue
        }).then(resp => {
            if (resp.data.status) {
                handleCloseDatePayment()
                getFacturas()
            } else {
                setMsgDangerModalDatePayment(resp.data?.errors)
            }
        }).catch(err => {
            setMsgDangerModalDatePayment(err?.response?.data?.errors || ["Error desconocido al guardar la fecha de pago."])
        }).finally(() => {
            setSpinerModalDatePayment(false)
        })
    }

    const filteredItems = useMemo(() => {
        if (!globalFilter) return transactions;
        const search = globalFilter.toLowerCase();
        return transactions.filter(row =>
            Object.values(row).some(
                val =>
                    typeof val === 'string' && val.toLowerCase().includes(search)
            )
        );
    }, [transactions, globalFilter]);

    useEffect(() => {
        if (serviciosAñadidos.find(s => s.serviceType !== "MANUAL")) {
            const tipoIvaActual = String(serviciosAñadidos.find(s => s.serviceType !== "MANUAL").iva);
            setIvaType(tipoIvaActual);
        }
    }, [serviciosAñadidos]);

    useEffect(() => {
        getFacturas()
        getClients()
        getServicesType()
    }, [open, modalSendTransaction]) // eslint-disable-line react-hooks/exhaustive-deps

    const [openMotivoModal, setOpenMotivoModal] = useState(false)
    const [motivoRechazoContent, setMotivoRechazoContent] = useState("")
    const handleOpenMotivoRechazo = (motivo) => {
        setMotivoRechazoContent(motivo)
        setOpenMotivoModal(true)
    }

    return (
        <Card>
            <div className="cointainer cointainer-bt">
                <h1>Facturas</h1>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <CronJobInfo />
                    <Button
                        onClick={handleOpenExport}
                        color="primary"
                        variant="outlined"
                        style={{ marginLeft: "10px", width: 200 }}
                    >
                        Exportar
                    </Button>
                    <Button
                        onClick={handleOpen}
                        color="primary"
                        variant="outlined"
                        style={{ width: 200, marginLeft: "10px", }}
                    >
                        Generar Factura
                    </Button>
                </div>
            </div>

            {msgSuccess && (
                <Box className="alert-success">
                    La factura se ha generado correctamente: <Link href={invoicePdf} target="_blank"
                        color="inherit">Mostrar</Link>
                </Box>
            )}

            {msgSuccessExport && (
                <Box className="alert-success">
                    La exportación se ha generado correctamente
                </Box>
            )}

            {msgDanger && (
                <Box className="alert-danger">
                    {msgDanger.map((item, index) => {
                        return (<span key={index}>{item} <br /></span>)
                    })}
                </Box>
            )}

            <LoadingProgress loading={loading} />
            {!loading && (
                <>
                    <TableC columns={columns} data={filteredItems || []} globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
                    <MotivoRechazoModal
                        open={openMotivoModal}
                        setOpen={setOpenMotivoModal}
                        motivo={motivoRechazoContent}
                    />
                </>
            )}
            <InvoiceModal
                open={open}
                handleClose={handleClose}
                spiner={spiner}
                msgDangerModal={msgDangerModal}
                invoiceTypeSpecial={invoiceTypeSpecial}
                setInvoiceTypeSpecial={setInvoiceTypeSpecial}
                invoiceID={invoiceID}
                handleChangeInvoiceID={handleChangeInvoiceID}
                dateOriginalBill={dateOriginalBill}
                dateBill={dateBill}
                handleChageDate={handleChageDate}
                listUserClient={listUserClient}
                defaultUserClientValueList={defaultUserClientValueList}
                changeClient={changeClient}
                servicioSeleccionado={servicioSeleccionado}
                setServicioSeleccionado={setServicioSeleccionado}
                servicios={servicios}
                serviciosAñadidos={serviciosAñadidos}
                setServiciosAñadidos={setServiciosAñadidos}
                tipoIva={tipoIva}
                setIvaType={setIvaType}
                iva={iva}
                setIva={setIva}
                price={price}
                handleChangePrice={handleChangePrice}
                motivo={motivo}
                setMotivo={setMotivo}
                concepto={concepto}
                setConcepto={setConcepto}
                createInvoice={createInvoice}
                spinerModal={spinerModal}
                setInvoinceID={setInvoinceID}
                setDateOriginalBill={setInvoinceID}
                setDateBill={setInvoinceID}
                setDefaultUserClientValueList={setInvoinceID}
                setIsClientSelect={setInvoinceID}
                setIdClient={setInvoinceID}
                setPrice={setPrice}
                invoiceShowPrice={invoiceShowPrice}
                setInvoiceShowPrice={setInvoiceShowPrice}
                subtotal={subtotal}
                dateOperation={dateOperation}
                setDateOperation={setDateOperation}
                setDateOperationOriginal={setDateOperationOriginal}
            />
            <ExportModal
                openExport={openExport}
                handleCloseExport={handleCloseExport}
                spinerModalExport={spinerModalExport}
                msgDangerModalExport={msgDangerModalExport}
                dateExportStart={dateExportStart}
                setDateExportStart={setDateExportStart}
                dateExportEnd={dateExportEnd}
                setDateExportEnd={setDateExportEnd}
                createExport={createExport}
            />
            <DatePaymentModal
                openDatePayment={openDatePayment}
                handleCloseDatePayment={handleCloseDatePayment}
                spinerModalDatePayment={spinerModalDatePayment}
                msgDangerModalDatePayment={msgDangerModalDatePayment}
                datePaymentValue={datePaymentValue}
                setDatePaymentValue={setDatePaymentValue}
                saveDatePayment={saveDatePayment}
                transactionId={selectedTransactionId}
            />
            <MotivoRechazoModal
                open={openMotivoModal}
                setOpen={setOpenMotivoModal}
                motivo={motivoRechazoContent}
            />
            <ModalSendTransaction
                open={modalSendTransaction}
                setOpen={setModalSendTransaction}
                transactionId={selectedTransactionId}
            />
        </Card>
    )
}

function ActionsMenu({ doc, handleDownload, handleDownloadXml, hrefClient, handleOpenDatePayment, handleResendVerifactu, handleOpenSendTransaction }) {
    // Estado para anclar el menú
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl)

    // Abre el menú
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    // Cierra el menú
    const handleClose = () => {
        setAnchorEl(null)
    }

    // Desactivar botón si verifactuEstadoAeat es "aceptado"
    const isVerifactuAceptado = doc.verifactuEstadoAeat && doc.verifactuEstadoAeat.toLowerCase() === "aceptado";

    return (
        <>
            {/* Botón de tres puntos */}
            <IconButton
                size="small"
                onClick={handleClick}
                sx={{ padding: "4px" }}
            >
                <MoreHorizIcon />
            </IconButton>

            {/* Menú desplegable */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledListHeader>Ver</StyledListHeader>
                {/* Opción Factura */}
                <MenuItem
                    disabled={!doc.file}
                    onClick={() => {
                        handleDownload(doc.file, `${doc.invoiceNumber}.pdf`);
                        handleClose();
                    }}
                >
                    Factura
                </MenuItem>

                {/* Opción XML si existe */}
                {doc.verifactuXml && (
                    <MenuItem
                        onClick={() => {
                            handleDownloadXml(doc.verifactuXml, doc);
                            handleClose();
                        }}
                    >
                        XML
                    </MenuItem>
                )}
                <Divider sx={{ my: 0.5 }} />
                <StyledListHeader>Editar</StyledListHeader>
                <MenuItem
                    onClick={() => {
                        handleOpenDatePayment(doc.id);
                        handleClose();
                    }}
                >
                    Fecha de Pago
                </MenuItem>
                <MenuItem
                    disabled={isVerifactuAceptado || doc.referencedInvoiceNumber || !doc.verifactuEstadoAeat}
                    onClick={() => {
                        handleResendVerifactu(doc.id);
                        handleClose();
                    }}
                >
                    Regenerar factura
                </MenuItem>
                <StyledListHeader>Cliente</StyledListHeader>
                <MenuItem
                    onClick={() => {
                        handleOpenSendTransaction(doc.id);
                        handleClose();
                    }}
                >
                    Reenviar Factura
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        window.location.href = hrefClient;
                        handleClose();
                    }}
                >
                    Editar
                </MenuItem>
            </Menu>
        </>
    )
}
